/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useQuery } from "@apollo/client";
import { AppAlert } from "../../../components/dialogue/Dialogue";
import { useAppSelector } from "../../../redux/hooks";
import { LeadsTable } from "./LeadTable";
import { setLeads } from "../../../redux/reducers";
import { Container } from "../../../globalstyled";
import AppLoader from "../../../components/loader";
import { GET_LEADS } from "../../../apolloClient/operation/querys/userQuery";
import { LeadResponse } from "../../../types/graphQlQuery.interface";
import { useAccess } from "../../../hooks/useAccess";
import { logEvent, LEAD_EVENTS } from "../../../utils/amplitude";

interface DashboardProps {}

export const Leads: React.FC<DashboardProps> = ({}) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const dispatch = useDispatch();

  const userReducer = useAppSelector((state) => state.userReducer);
  const { leads } = userReducer;

  const { loading, error, data } = useQuery<
    LeadResponse,
    { limit: number; offset: number }
  >(GET_LEADS, {
    variables: { limit: 100, offset: 0 },
  });

  // Use the global hook for access permissions
  const { loading: accessLoading } = useAccess();

  useEffect(() => {
    onFetchLeads();
  }, [loading, error, data, dispatch]);

  const onFetchLeads = () => {
    if (!loading && !error && data) {
      dispatch(setLeads(data.leads));
      
      // Track page viewed (excluding waitlist leads)
      const nonWaitlistLeads = data.leads.filter((lead: any) => lead.utm !== 'waitlist');
      logEvent(LEAD_EVENTS.LEADS_PAGE_VIEWED, { 
        lead_count: nonWaitlistLeads.length 
      });
      
      setIsLoading(false);
    } else if (error) {
      console.error("Error fetching leads:", error);
      setIsLoading(false);
    }
  };

  if (isLoading || accessLoading) {
    return <AppLoader isLoading={isLoading || accessLoading} />;
  }

  const hostContainer = () => {
    return (
      <Container>
        <AppAlert
          open={false}
          title={`Reset Password!`}
          message={"Are you sure to Reset Your Password?"}
          onClose={() => {}}
          onConfirm={() => {}}
        />
        <LeadsTable leads={leads} />
      </Container>
    );
  };

  return hostContainer();
};
